import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import State from '../state/State';
import {
  entriesSelector, shopsGroupedByStateSelector,
  viewAllShopsSelector, canadaStoresByStateSelector,
  usaStoresByStateSelector, selectedStateSelector,
} from '../../selectors/shops';
import DEFAULT_SELECTORS from '../../constants/selector';
import styles from './AllStores.module.sass';

class AllStores extends React.PureComponent {
  render() {
    const {
      viewAllShops, shopsGroupedByState, selectedState, usaStoresByState, canadaStoresByState,
    } = this.props;

    let selectedStores = {};

    switch (selectedState) {
      case DEFAULT_SELECTORS.USA:
        selectedStores = usaStoresByState;
        break;
      case DEFAULT_SELECTORS.CANADA:
        selectedStores = canadaStoresByState;
        break;
      default:
        selectedStores = Object.defineProperty(
          {},
          selectedState,
          { value: shopsGroupedByState[selectedState], enumerable: true },
        );
    }
    const [firstState] = Object.keys(selectedStores);
    return (
      viewAllShops && Object.keys(selectedStores).length > 0 && (
        <div className={styles['stores-container']}>
          { Object.entries(selectedStores).map(([state, stores]) => (
            <State isOpened={state === firstState} key={state} state={state} stores={stores} />
          ))}
        </div>
      )
    );
  }
}

const mapStateToProps = (state) => ({
  shops: entriesSelector(state),
  viewAllShops: viewAllShopsSelector(state),
  shopsGroupedByState: shopsGroupedByStateSelector(state),
  usaStoresByState: usaStoresByStateSelector(state),
  canadaStoresByState: canadaStoresByStateSelector(state),
  selectedState: selectedStateSelector(state),
});

AllStores.propTypes = {
  shopsGroupedByState: PropTypes.shape({}).isRequired,
  viewAllShops: PropTypes.bool.isRequired,
  selectedState: PropTypes.string.isRequired,
  usaStoresByState: PropTypes.shape({}).isRequired,
  canadaStoresByState: PropTypes.shape({}).isRequired,
};

export default connect(mapStateToProps)(AllStores);
